module.exports = "<p>\n  home works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// D:/xampp_bk/htdocs/xampp/organicshop/src/app/core/components/home/home.component.html
// module id = ../../../../../src/app/core/components/home/home.component.html
// module chunks = 1